<div [cm-tooltip]="tooltipText">
    {{ text }}
</div>
